import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.format()
  }

  format() {
    const input = this.hasInputTarget ? this.inputTarget : this.element
    let value = input.value.replace(/\D/g, "")

    if (value.length > 11) {
      value = value.slice(0, 11)
    }

    if (value.length > 0) {
      // Format: (XX) XXXXX-XXXX or (XX) XXXX-XXXX
      if (value.length <= 2) {
        value = `(${value}`
      } else if (value.length <= 7) {
        value = `(${value.slice(0, 2)}) ${value.slice(2)}`
      } else {
        const ddd = value.slice(0, 2)
        const firstPart = value.slice(2, 7)
        const secondPart = value.slice(7, 11)
        value = `(${ddd}) ${firstPart}-${secondPart}`
      }
    }

    input.value = value
  }

  onInput(event) {
    const input = event.target
    const cursorPosition = input.selectionStart
    const previousLength = input.value.length

    this.format()

    // Adjust cursor position after formatting
    const newLength = input.value.length
    const diff = newLength - previousLength
    const newPosition = Math.max(0, cursorPosition + diff)

    // Use requestAnimationFrame to ensure cursor is set after value update
    requestAnimationFrame(() => {
      input.setSelectionRange(newPosition, newPosition)
    })
  }

  onKeyDown(event) {
    const input = event.target
    const key = event.key

    // Allow: backspace, delete, tab, escape, enter, arrows
    const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"]
    if (allowedKeys.includes(key)) {
      return
    }

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x"].includes(key.toLowerCase())) {
      return
    }

    // Block non-numeric keys
    if (!/^\d$/.test(key)) {
      event.preventDefault()
      return
    }

    // Block if already at max length (11 digits)
    const currentDigits = input.value.replace(/\D/g, "")
    if (currentDigits.length >= 11) {
      event.preventDefault()
    }
  }

  onPaste(event) {
    event.preventDefault()
    const pastedText = (event.clipboardData || window.clipboardData).getData("text")
    const digits = pastedText.replace(/\D/g, "").slice(0, 11)

    const input = event.target
    const currentDigits = input.value.replace(/\D/g, "")
    const start = input.selectionStart
    const end = input.selectionEnd

    // Calculate position in digits (not formatted string)
    let digitPosition = 0
    for (let i = 0; i < start && i < input.value.length; i++) {
      if (/\d/.test(input.value[i])) {
        digitPosition++
      }
    }

    // Replace selected digits with pasted digits
    const selectedDigitsCount = input.value.slice(start, end).replace(/\D/g, "").length
    const newDigits = currentDigits.slice(0, digitPosition) + digits + currentDigits.slice(digitPosition + selectedDigitsCount)

    input.value = newDigits.slice(0, 11)
    this.format()
  }
}
